<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Demo Mode
        </h3>
        <p class="text--secondary">
          Configure demo mode settings for development and testing.
        </p>
      </v-col>
    </v-row>
    <!-- Demo mode settings will be implemented here -->
    <div class="text-center py-8 text--secondary">
      Demo mode settings coming soon...
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsDemo',
  props: {
    demoMode: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
